// ============================================================
// Nachgeladene Chunks — Selbstheilung bei veralteter Huelle.
//
// Hier stand bis zuletzt alles in App.tsx. Es zog dorthin um, weil nicht nur
// die Bildschirme nachgeladen werden: auch das Diagrammmodul (echarts) kommt
// ueber ein dynamisches import() herein und braucht denselben Rueckweg. Zwei
// Fassungen desselben Riegels waeren zwei Fassungen zu viel — sie teilen sich
// EINEN sessionStorage-Schluessel, also muessen sie sich auch eine Datei
// teilen.
// ============================================================

/** Riegel gegen die Neuladeschleife — auch die Fehlergrenze loest ihn wieder. */
export const CHUNK_KEY = "spg.chunk-reload";
/** Innerhalb dieser Spanne gilt ein zweiter Fehlschlag als echter Defekt. */
const CHUNK_RETRY_MS = 20_000;

/** sessionStorage kann werfen (privates Fenster, gesperrte Website-Daten). */
function sessionGet(k: string): string | null {
  try {
    return sessionStorage.getItem(k);
  } catch {
    return null;
  }
}
function sessionSet(k: string, v: string): void {
  try {
    sessionStorage.setItem(k, v);
  } catch {
    /* ohne Speicher gibt es keinen Riegel — dann eben ein Versuch mehr */
  }
}

/**
 * Ein Chunk-Import scheitert aus genau einem interessanten Grund: der Browser
 * laeuft noch mit einer index.html aus einem aelteren Build, deren gehashte
 * Chunk-Namen nach einem Deployment 404 liefern. Einmal neu laden holt die
 * frische Huelle und alles ist gut.
 *
 * Der Riegel war frueher ein blosses „schon einmal passiert" und wurde NIE
 * zurueckgesetzt. Beim zweiten Deployment derselben Browsersitzung fiel der
 * Import deshalb ungebremst durch — und ohne Fehlergrenze darunter blieb der
 * Bildschirm einfach LEER. Genau das war der Fall „die Karte laedt nicht".
 * (Nachgestellt: Chunk auf 404 gesetzt, Riegel gesetzt → weisse Seite.)
 *
 * Jetzt merkt sich der Riegel den ZEITPUNKT. Ein Fehlschlag kurz nach dem
 * letzten Neuladen ist ein echter Defekt und wird durchgereicht; ein
 * Fehlschlag Stunden spaeter ist das naechste Deployment und laedt wieder neu.
 */
export function retryOnStaleShell<T>(p: Promise<T>): Promise<T> {
  return p.catch((e: unknown) => {
    const last = Number(sessionGet(CHUNK_KEY) ?? 0);
    if (Number.isFinite(last) && last > 0 && Date.now() - last < CHUNK_RETRY_MS) throw e;
    sessionSet(CHUNK_KEY, String(Date.now()));
    window.location.reload();
    return new Promise<T>(() => undefined); // wird nie erfuellt; das Neuladen uebernimmt
  });
}

/**
 * Riegel loesen, damit ein Neuladen wirklich einen neuen Versuch bekommt —
 * sonst gilt der naechste Fehlschlag innerhalb der Spanne als echter Defekt
 * und die Selbstheilung bliebe genau da stehen, wo sie gebraucht wird.
 */
export function chunkRiegelLoesen(): void {
  try {
    sessionStorage.removeItem(CHUNK_KEY);
  } catch {
    /* ohne Speicher genuegt das Neuladen */
  }
}
